import {createContext, Dispatch, SetStateAction} from 'react';

export enum ETableMode {
    EDIT = 'edit',
    VIEW = 'view',
}

export const invertTableMode = (mode: ETableMode) => {
    switch (mode) {
    case ETableMode.VIEW:
        return ETableMode.EDIT;
    default:
        return ETableMode.VIEW;
    }
};

export interface ITableModeContextArgs {
    tableMode: ETableMode;
    resetTableMode: () => void;
    setTableMode: Dispatch<SetStateAction<ETableMode>>;
}

export const TableModeContext = createContext<ITableModeContextArgs>({
    tableMode: ETableMode.VIEW,
    setTableMode: () => {
    },
    resetTableMode: () => {
    },
});
